import request from "@/utils/request"

const create = (event) =>
  request.post("/api/events", {
    body: {
      event
    },
    token: true
  })

export default {
  create
}
